// extracted by mini-css-extract-plugin
module.exports = {"root":"newsletter-area_root__WtU4R","newsletter":"newsletter-area_newsletter__P9glk"};